import { Check, X } from "lucide-react";
import { Reveal } from "./Reveal";
import { comparison } from "@/data/site";
import { useLeadModal } from "@/context/LeadModalContext";

export const Comparison = () => {
  const { openModal } = useLeadModal();
  return (
    <section className="bg-ivory py-20 sm:py-28" data-testid="comparison">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-6">CAPITOLO 04 — IL CONFRONTO</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-light text-ink text-4xl sm:text-6xl lg:text-7xl leading-[1.0] tracking-tight mb-16 max-w-3xl">
            La tua collezione.<br />La nostra infrastruttura.
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-px bg-[rgba(17,17,17,0.12)] border hairline" data-testid="comparison-table">
          {/* Traditional */}
          <Reveal className="bg-ivory">
            <div className="p-8 sm:p-12 h-full">
              <p className="font-sans-ui text-[10px] tracking-mega text-ink/40 mb-2">MODELLO A</p>
              <h3 className="font-display text-3xl sm:text-4xl text-ink/60 mb-8">{comparison.traditional.title}</h3>
              <ul className="space-y-4">
                {comparison.traditional.items.map((it) => (
                  <li key={it} className="flex items-start gap-4 font-sans-ui text-sm sm:text-base text-ink/55">
                    <X size={17} className="mt-0.5 shrink-0 text-ink/35" strokeWidth={1.5} />
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          {/* MBO */}
          <Reveal delay={0.1} className="bg-ink text-ivory">
            <div className="p-8 sm:p-12 h-full">
              <p className="font-sans-ui text-[10px] tracking-mega text-goldtan mb-2">MODELLO B</p>
              <h3 className="font-display text-3xl sm:text-4xl text-ivory mb-8">{comparison.mbo.title}</h3>
              <ul className="space-y-4">
                {comparison.mbo.items.map((it) => (
                  <li key={it} className="flex items-start gap-4 font-sans-ui text-sm sm:text-base text-ivory/90">
                    <Check size={17} className="mt-0.5 shrink-0 text-goldtan" strokeWidth={1.75} />
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.05}>
          <div className="mt-12 flex justify-center">
            <button
              data-testid="comparison-cta"
              onClick={openModal}
              className="inline-flex items-center bg-ink text-ivory px-10 py-4 text-[11px] tracking-mega font-medium hover:bg-charcoal transition-colors duration-300"
            >
              SCOPRI SE MBO FA PER TE
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
